import styled, { css } from 'styled-components'
import { h1_bold } from '../../theme/type-styles'
import { gray_7 } from '../../theme/colors';
import { spacing_1 } from '../../theme/spacing';
import { xsMd } from '../../theme/utils/media-query'

export function makeHeader (element, baseStyle = null) {
  return styled(element)`
    ${baseStyle || h1_bold};
    color: ${props => props.color || gray_7};
    margin-bottom: ${props => props.marginBottom || spacing_1};
    margin-top: ${props => props.marginTop || spacing_1};
    ${props => props.textAlign && css`
      text-align: ${props.textAlign};
    `}
  
    ${xsMd(css`
      margin-bottom: ${props => props.marginBottomMobile || spacing_1};
    `)}
  `
}

export default makeHeader
